export const setFavicon = (code: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const favicon: any = document.querySelector("link[rel*='icon']")
  if (!favicon) return

  if (window.brandingCode === 'usbl') {
    // This is a temporary check, dont wanna commit to adding all these new logos in snorre yet
    // TODO: remove
    favicon.href = `${
      window.config.urls.themesUrl
    }${code.toLocaleLowerCase()}/portal/favicon.ico`
    return
  }

  favicon.href = `${
    window.config.urls.themesUrl + window.brandingCode
  }/favicon.ico`
}

export const getLogo = () => {
  if (window.brandingCode === 'usbl') {
    return `${
      window.config.urls.themesUrl + window.brandingCode
    }/portal/logo.png`
  }
  return `${window.config.urls.themesUrl + window.brandingCode}/logo.png`
}

export const getLogoInverted = (isFooter: boolean = false) => {
  if (window.brandingCode === 'usbl') {
    return `${
      window.config.urls.themesUrl + window.brandingCode
    }/portal/logo-inverted.png`
  }
  if (window.brandingCode === 'arendal') {
    if (isFooter) {
      return `${
        window.config.urls.themesUrl + window.brandingCode
      }/logo-inverted.png`
    }
    return `${window.config.urls.themesUrl + window.brandingCode}/logo.png`
  }
  if (window.brandingCode === 'bosor') {
    if (isFooter) {
      return `${window.config.urls.themesUrl + window.brandingCode}/logo.png`
    }
    return `${
      window.config.urls.themesUrl + window.brandingCode
    }/logo-inverted.png`
  }
  return `${
    window.config.urls.themesUrl + window.brandingCode
  }/logo-inverted.png`
}

export function isUsbl() {
  return window.brandingCode === 'usbl'
}

export function isBosor() {
  return window.brandingCode === 'bosor'
}

export function isArendal() {
  return window.brandingCode === 'arendal'
}
